import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, FormCheckbox, Wrapper } from 'components/Ui';
import { Link } from 'react-router-dom';
import { getToUrl } from 'utils/translation';
import styles from './styles.scss';

const TotalBlock = ({
  page,
  handlePlaceOrder,
  loading,
  isSendNews,
  onChange,
  summary: { total, recurringCharge },
}) => (
  <Wrapper className={styles.totalContainer}>
    <div className={classnames(styles.row, styles.marginBtm)}>
      <div>
        <div className={styles.boldText}>ORDER TOTAL</div>
        <div className={styles.regularText}>
          Due now. Includes first month payment.
        </div>
      </div>
      <div className={styles.priceText}>${total}</div>
    </div>
    <div className={classnames(styles.row, styles.marginBtm)}>
      <div>
        <div className={styles.priceRegularText}>
          Estimated recurring invoice
        </div>
        <div className={styles.italicText}>
          Your card will be automatically charged monthly.
        </div>
        <div className={styles.italicText}>
          Please refer to{' '}
          <Link to={getToUrl('/terms-of-use', 'U60')} target="_blank">
            Terms & Conditions
          </Link>{' '}
          to learn more.
        </div>
      </div>
      <div className={styles.priceRegularText}>${recurringCharge}/mo</div>
    </div>
    {page !== 'cart' ? (
      <div className={styles.row}>
        <FormCheckbox
          label={
            <div className={styles.checkboxLabel}>
              <div className={styles.text}>Please send me news & offers</div>
              <div className={styles.subtext}>
                You can change communication preferences in{' '}
                <Link to="/account/profile" target="_blank">
                  My Account
                </Link>
              </div>
            </div>
          }
          checked={isSendNews}
          onChange={onChange}
        />
        <Button
          text="Place Order"
          onClick={handlePlaceOrder}
          loading={loading}
        />
      </div>
    ) : (
      <div className={styles.checkoutButton}>
        <Button
          style={{ minWidth: 222 }}
          href="/checkout/account"
          text="Checkout"
        />
      </div>
    )}
  </Wrapper>
);

TotalBlock.propTypes = {
  page: PropTypes.oneOf(['cart', 'checkout']),
  handlePlaceOrder: PropTypes.func,
  loading: PropTypes.bool,
  isSendNews: PropTypes.bool,
  onChange: PropTypes.func,
  summary: PropTypes.shape({
    total: PropTypes.number,
  }),
};

TotalBlock.defaultProps = {
  page: 'checkout',
  isSendNews: false,
  onChange: () => {},
};

export default TotalBlock;
